import React from "react";
import { Routes, Route } from "react-router-dom";
import Settings from "./SettingsTab";
import AccessControlRoutes from "./AccessControlRoutes";

// Define all settings tab paths
const settingsTabPaths = [
  "clients",
  "add-client",
  "edit-client",
  "login-history",
];

const SettingsRoutes = () => {
  return (
    <Routes>
      {/* Regular Settings Tabs */}
      {settingsTabPaths.map((tab) => (
        <Route key={tab} path={tab} element={<Settings />} />
      ))}

      {/* Submodule Routes */}
      <Route path="access-control/*" element={<AccessControlRoutes />} />
    </Routes>
  );
};

export default SettingsRoutes;
